import $ from 'jquery';
import UserRatesRepository from './repository';
import UserRatesTimer from './timer';

import { siteModel } from 'models/SiteModel';
import { scroller as loginBarScroller } from '@ui/login-bar/scroller';

const $container = $('.article-content--rating');
const $configuration = $container.find('.rating-configuration');

const voteAPI = $configuration.data('match-ratings-vote-api');
const userAPI = $configuration.data('match-ratings-user-api');

const match = $configuration.data('match-id');
const matchRatingId = $configuration.data('match-rating-id');

const repository = new UserRatesRepository({ endpoints: { vote: voteAPI, user: userAPI }, data: { match } });

const authenticate = () => {
    const authenticated = siteModel.isUserLogged();
    if (!authenticated) {
        loginBarScroller();
    }
    return authenticated;
};

const initialize = ($widget, loaded) => {
    if (loaded) {
        let value = null;

        if ($widget.data('type') === 'player') {
            const playerId = $widget.data('player-id');
            value = loaded.players[playerId];
        } else {
            const key = $widget.data('rate-key');
            value = loaded.other[key];
        }

        if (value) {
            $widget.data('rating', value).addClass('is-rated');
        }
    }

    const rating = $widget.data('rating');
    if (rating) {
        $widget.find('li').each((i, o) => {
            const nth = i + 1;
            const $item = $(o);

            $item.removeClass('active current');

            if (nth <= rating) {
                $item.addClass('active');
            }
            if (nth === rating) {
                $item.addClass('current');
            }
        });
        return true;
    }
    return false;
};

const stars = $widget => {
    const $items = $widget.find('li');
    $items.each((i, o) => {
        const $item = $(o);
        $item.off();
        $item.on('mouseenter', () => {
            const index = $items.index($item) + 1;
            $items.removeClass('hovered');
            $items.filter(`:lt(${index})`).addClass('hovered');
        });
        $item.on('click', () => {
            if (!authenticate()) {
                return false;
            }

            const index = $items.index($item) + 1;
            $items.removeClass('hovered');
            $widget
                .data('selected', index)
                .data('rating', index)
                .addClass('is-rated');

            initialize($widget, false);
        });
    });
    $widget.off().on('mouseleave', () => {
        $items.removeClass('hovered');
    });
};

const scroller = $element => {
    if (!$element.length) {
        return false;
    }
    const $header = $('header');
    const offset = $element.offset().top - $header.outerHeight() - 20;

    $('html, body').animate({ scrollTop: offset }, 500);
    return true;
};

const load = () => {
    const promise = (resolve, reject) => {
        const authenticated = siteModel.isUserLogged();
        if (!authenticated) {
            return resolve(false);
        }

        repository
            .load(matchRatingId)
            .then(data => resolve(data))
            .catch(() => resolve(false));
    };

    return new Promise(promise);
};

const start = loaded => {
    const $submit = $container.find('.rating-footer button');
    const $error = $container.find('.user-rating-error');
    const $success = $container.find('.user-rating-success');

    $submit.removeClass('hidden');
    $success.addClass('hidden');
    $error.addClass('hidden');

    const $widgets = $container.find('.rating--widget');

    let voted = false;
    $widgets.each((i, o) => {
        const $widget = $(o);
        if (initialize($widget, loaded)) {
            voted = true;
        }
        stars($widget);
    });

    if (voted) {
        $submit.text($submit.data('label'));
    }

    const payload = () => {
        const p = {
            matchId: match,
            players: [],
            other: {},
        };
        let validated = false;

        $widgets.each((i, o) => {
            const $widget = $(o);
            const id = $widget.data('player-id');
            const key = $widget.data('rate-key');
            const rate = $widget.data('selected');

            if (rate) {
                switch ($widget.data('type')) {
                    case 'player':
                        p.players.push({ id, rate });
                        validated = true;
                        break;
                    case 'other':
                        p.other[key] = rate;
                        validated = true;
                        break;
                    default:
                }
            }
        });

        if (!validated) {
            return false;
        }

        return p;
    };

    const $timer = $container.find('.rating-time-left').first();

    const timer = new UserRatesTimer($timer);
    timer.onFinish(() => {
        $submit.prop('disabled', true);
        $submit.addClass('hidden');

        $widgets.each((i, o) => {
            const $widget = $(o);
            $widget.off();
            $widget.find('li').off();
        });
    });
    timer.start();

    $submit.off().on('click', () => {
        $error.addClass('hidden');

        if (!authenticate()) {
            return false;
        }
        const data = payload();
        if (data) {
            repository.vote(data).then(
                () => {
                    $submit.addClass('hidden');
                    $success.removeClass('hidden');
                    scroller($success);
                    timer.reset();

                    $widgets.each((i, o) => {
                        const $widget = $(o);
                        $widget.off();
                        $widget.find('li').off();
                    });
                },
                () => {}
            );
        } else {
            $error.text($error.data('no-data'));
            $error.removeClass('hidden');
        }
        return true;
    });

    return true;
};

export default {
    init() {
        $(document).ready(() => {
            if (!$container.length) {
                return;
            }

            load().then(data => {
                start(data);
            });

            const $success = $container.find('.user-rating-success');

            $success
                .find('a')
                .off()
                .on('click', () => {
                    scroller($container);
                    start();
                });
        });
    },
};



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/user-rates/voting.js